<template>
  <div id="photoviewdb">
    <CoolLightBox
      :items="filteredImages"
      :index="index"
      loop
      overlayColor="rgba(30,30,30,1)"
      @close="index = null"
      oncontextmenu="return false;"
    ></CoolLightBox>

    <v-container id="photoviewdb">
      <v-row justify="space-around">
        <v-col
          v-for="(thumb, imageIndex) in filteredImages"
          :key="imageIndex"
          cols="12"
          sm="6"
          md="4"
          lg="4"
        >
          <v-card max-width="370" :hover="cardhover">
            <v-img
              @click="setIndex(imageIndex)"
              :src="thumb.src"
              oncontextmenu="return false;"
              hover="false"
              class="pageimage"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="black lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-system-bar window>
              <span>{{ thumb.title }}</span>
              <v-spacer></v-spacer>
              <PhotoInfo :data="thumb" />
            </v-system-bar>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import firebaseApp from "@/fb";
import PhotoInfo from "./PhotoInfo";
import _ from "lodash";

export default {
  name: "photoviewdb",
  props: ["pagename", "galleryFilter"],
  components: {
    CoolLightBox,
    PhotoInfo,
  },
  data() {
    return {
      items: [],
      // galleryFilter: "all",
      index: null,
      cardhover: true,
      showinfocard: false,
    };
  },
  methods: {
    updateFilter(filterName) {
      this.galleryFilter = filterName;
    },
    setIndex(index) {
      this.index = index;
    },
  },
  computed: {
    filteredImages: function () {
      if (this.galleryFilter === "all") {
        return _.orderBy(this.items, "taken", "desc");
      } else {
        return _.orderBy(
          this.items.filter((image) => image.filter === this.galleryFilter),
          "taken",
          "desc"
        );
      }
    },
  },
  created() {
    const db = firebaseApp.firestore();
    const storage = firebaseApp.storage().ref();
    const _this = this;
    const items = [];

    if (this.galleryFilter === "all") {
      db.collection("gallery")
        .orderBy("taken", "desc")
        .limit(12)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            items.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          return Promise.all(
            items.map((item) => {
              return storage
                .child(item.imagestore)
                .getDownloadURL()
                .then((url) => {
                  item.src = url;
                  _this.items.push(item);
                });
            })
          );
        })
        .then(() => {
          console.log(this.items);
        });
    } else {
      db.collection("gallery")
        .where("filter", "==", this.galleryFilter)
        .orderBy("taken", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            items.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          return Promise.all(
            items.map((item) => {
              return storage
                .child(item.imagestore)
                .getDownloadURL()
                .then((url) => {
                  item.src = url;
                  _this.items.push(item);
                });
            })
          );
        })
        .then(() => {
          console.log(this.items);
        });
    }
  },
};
</script>

<style scoped>
#photoviewdb {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  /* margin-top: 60px; */
  background: white;
  background-size: cover;
}

.bodyrock {
  border-color: black;
  color: black;
}

#filters {
  width: 500px;
  margin: 10px auto;
  border-color: black;
  color: black;
}

#filters span {
  margin: 15px;
}

.pageimage {
  width: 360px;
  height: 250px;
  margin: 5px;
  /* border-radius: 3px; */
  border: 3px solid black;
  cursor: pointer;
  transition: all 0.4s ease;
}

.one-line {
  overflow: hidden;
  /* text-overflow: ellipsis; */
  white-space: nowrap;
}

.thumbnailfade-leave-active,
.thumbnailfade-enter-active {
  transition: all 0.4s ease;
}

.thumbnailfade-enter-active {
  transition-delay: 0.4s;
}

.thumbnailfade-enter,
.thumbnailfade-leave-to {
  opacity: 0;
}
</style>
